import React from 'react'
import { ThemeContext } from 'styled-components'
import { TypographyTypes } from '../../constants'
import H1 from './H1'
import H2 from './H2'
import H3 from './H3'
import H4 from './H4'
import P from './P'

const TYPOGRAPHY_COMPONENTS = Object.freeze({ H1, H2, H3, H4, P })

const Typography = ({
    type = TypographyTypes.P,
    children,
    className,
    variant,
    style,
}) => {
    const themeContext = React.useContext(ThemeContext)
    return React.createElement(
        TYPOGRAPHY_COMPONENTS[type],
        {
            themeContext,
            style,
            className: `rds-typography ${className || ''}`,
            variant,
        },
        children,
    )
}

export default Typography
